export function isDevelopment() {
  // 测试环境打包
  if (process.env.NODE_ENV === 'development') {
    return true
  } else {
    return false
  }
  // if (process.env.NODE_ENV === "development") {
  //   return false
  // } else {
  //   return true
  // }
}
